module.exports = __webpack_public_path__ + "static/assets/aca21772a37e26761da9d791044f4e45.png";